import { html } from 'lit-element';
import 'Components/Global/SVGIcon';
import 'Components/Global/SifiveRoundButton';

function getFacebookUrl(name) {
    return `https://www.facebook.com/${name}`
}

export const viewOrganization = function(orgData, { startEditMode }) {

    const { name, location, website, email, description,
        facebookUrl, instagramUrl, twitterUrl, youtubeUrl } = orgData

    return html`
        <div class="wrapper">
            <section class="org-top-section-container">
                <div class="org-top-section">
                    <div><img src="assets/images/berkeley_sample.png" alt=""/></div>
                    <div class="middle">
                       <h4 class="mb-2-5">${name} 
                            <sifive-round-button class="icon-edit" @click=${startEditMode}>
                                <svg-icon slot="icon" src="assets/images/icons/edit.svg"></svg-icon>
                            </sifive-round-button>
                        </h4>
                       <div>
                           <span><svg-icon class="icon-location" src="assets/images/icons/location.svg"></svg-icon>${location}</span>
                           ${website && html`<span class="ml-3"><a href="${website}">Visit Website</a></span>`}
                       </div>
                    </div>
                    <div class="right">
                        <p class="mb-1">Member Since 38 JUN 2019</p>
                        <div class="social-icons">
                            ${facebookUrl &&
                                html`<a href=${getFacebookUrl(facebookUrl)} title="Facebook" class="social-icon">
                                    <svg-icon slot="icon" src="assets/images/icons/social/facebook.svg"></svg-icon></a>`}
                            ${instagramUrl &&
                                html`<a href=${instagramUrl} title="Instagram" class="social-icon">
                                    <svg-icon slot="icon" src="assets/images/icons/social/instagram.svg"></svg-icon></a>`}
                            ${twitterUrl &&
                                html`<a href=${twitterUrl} title="Twitter" class="social-icon">
                                <svg-icon slot="icon" src="assets/images/icons/social/twitter.svg"></svg-icon></a>`}
                            ${youtubeUrl &&
                                html`<a href=${youtubeUrl} title="Youtube" class="social-icon">
                                <svg-icon slot="icon" src="assets/images/icons/social/youtube.svg"></svg-icon></a>`}
                        </div>
                        <a href="mailto:learn@berkeleycollege.edu">${email}</a>
                    </div>
                </div>
                <section class="org-intro-section">
                    <h5 class="main-left-column">Introduction</h5>
                    <div class="main-right-column">
                        ${description}
                    </div>
                </section>
            </section>

            <section class="mt-4">
                <div class="flex-display">
                    <div>
                        <span class="small-number">06</span>
                        <span class="bold">Teams</span>
                    </div>
                    <div>
                        <span class="small-number">378</span>
                        <span class="bold">Learners</span>
                    </div>
                    <div>
                        <span class="small-number">12</span>
                        <span class="bold">Assessors</span>
                    </div>
                </div>
            </section>
        </div>
    `
}